import ResponsiveDialog from '~/src/components/mui-wrappers/responsive-dialog'
import { AuthenticationFlowDialogNameEnum } from '~/src/types/DialogNameEnum'
import { useMediaQuery } from '@mui/material'
import { CustomMuiTheme, useCustomMuiTheme } from '~/src/hooks/useCustomMuiTheme'
import { useTranslations } from '~/src/hooks/useTranslations'
import AuthenticationDialogTitle from '~/src/components/auth/dialogs/AuthenticationDialogTitle'
import ResetPasswordForm from '~/src/components/auth/reset-password/ResetPasswordForm'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'
import useRouterReplace from '~/src/hooks/router/useRouterReplace'

const ResetPasswordDialog = () => {
  const theme = useCustomMuiTheme()
  const { t } = useTranslations()
  const { replace } = useRouterReplace()
  const isSmallDevice = useMediaQuery((theme: CustomMuiTheme) => theme.breakpoints.down('md'))
  const { restart } = useAuthenticationFlowDialogs()

  const handleOnBackClick = () => {
    const url: URL = new URL(window.location.href)

    url.searchParams.delete('token')
    url.searchParams.delete('timestamp')
    replace(url.toString())

    restart()
  }

  return (
    <ResponsiveDialog
      openByDefault={true}
      name={AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_RESET_PASSWORD}
      showPuller={isSmallDevice}
      persistent
      Title={
        <AuthenticationDialogTitle
          showBackButton={true}
          onBack={handleOnBackClick}>
          { t('auth.resetPassword.dialog.title') }
        </AuthenticationDialogTitle>
      }
      titleSx={{
        px: `${theme.spacing(2)} !important`,
        gap: 1
      }}
      contentSx={{
        px: 3
      }}>
      <ResetPasswordForm fieldsColor='container'/>
    </ResponsiveDialog>
  )
}

export default ResetPasswordDialog
